import { ItemDiscountConfig } from 'apis/restaurant-api/merchant-admin/campaigns/types';

export const getItemDiscountIds = (itemDiscount: ItemDiscountConfig | undefined) => {
  // We don't have support for multi-venue campaigns yet, so just take all item ids regardless of venue
  const itemIds =
    itemDiscount?.include?.items?.flatMap(item => item.item_ids) ??
    (itemDiscount?.target_item?.item_id ? [itemDiscount.target_item.item_id] : []);

  const categoryIds = itemDiscount?.include?.categories?.flatMap(venueCategories => venueCategories.category_ids) ?? [];

  return { itemIds, categoryIds };
};
